import React, { FC } from 'react';
import { ManageWebhooks as Screen } from '@dev/ee-modules';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { compose } from 'react-recompose';
import { push as Push } from 'redux-first-history';
import { WebhookPayload } from '@dev/ee-api/ee-api-models';

import dayjs from '@/services/tools/dayjs';
import { ApplicationState as State } from '@/store';
import { ShowDialog } from '@/store/dialog/actions';
import { ShowDialogParams } from '@/store/dialog/types';
import { LoadWebhooks, UpdateWebhook } from '@/store/webhooks/actions';
import { SettingsPaths } from '@/services/dictionaries/Paths';

import Props from './WebhooksInterface';

import i18n from '../../../../i18n';
const mapState = (state: State, ownProps: Props): Props => ({
    ...ownProps,
    account: state.account,
    browser: state.browser,
    dialog: state.dialog,
    webhooks: state.webhooks,
});
const dispatchProps = {
    ShowDialog,
    LoadWebhooks,
    UpdateWebhook,
    Push,
};
interface DispatchProps {
    ShowDialog(params: ShowDialogParams): void;
    LoadWebhooks(): void;
    UpdateWebhook(publicId: string, webhook: WebhookPayload): void;
    Push(url: string): void;
}

type ExtendedProps = Props & DispatchProps;

// eslint-disable-next-line
const translations = [
    i18n.t('trackbounceerrordesc'),
    i18n.t('trackclickeddesc'),
    i18n.t('trackcomplaintsdesc'),
    i18n.t('tracknotifyoncedesc'),
    i18n.t('trackopeneddesc'),
    i18n.t('tracksentdesc'),
    i18n.t('trackunsubscribeddesc'),
    i18n.t('validdomains'),
    i18n.t('validdomains_desc'),
];

const ManageWebhooks: FC<ExtendedProps> = (props: ExtendedProps): JSX.Element => (
    <Screen dayjs={dayjs} paths={SettingsPaths} {...props} />
);

export default compose(
    withTranslation('settings'),
    connect<Props, DispatchProps>(mapState, dispatchProps)
)(ManageWebhooks);
